// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"88b11667","92":"4ab0643b","247":"bb45300d","320":"b02939ac","422":"d35c7ed2","604":"436ed0d2","616":"e43b818a","627":"19d01927","653":"c6536fb1","834":"984ec8dd","849":"4b226520","867":"9971367e","875":"12ce4476","923":"6d955867","938":"86dd392b","950":"9a517880"}[chunkId] + ".chunk.js";
};